<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-input size="small" placeholder="请输入医生姓名" v-model="query.userName"
                              style="width: 240px" suffix-icon="el-icon-search">
                    </el-input>
                    <el-date-picker size="small" v-model="query.startTime" type="date" placeholder="开始时间" style="width: 140px;margin-left: 20px"></el-date-picker>
                    <el-date-picker  size="small" v-model="query.endTime" type="date" placeholder="结束时间" style="width: 140px;margin-left: 20px"></el-date-picker>
                    <el-button type="primary" @click="search" style="width: 96px">查询</el-button>
                </div>
               
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="doctorName" label="医生姓名"></el-table-column>
                    <el-table-column prop="phoneNumber" label="手机号"></el-table-column> 
                    <el-table-column prop="gmtCreated" label="登录时间" :formatter="dateFormat"></el-table-column>
                    <el-table-column prop="deviceType" label="设备类型"></el-table-column>
                    <el-table-column prop="deviceName" label="设备名称"></el-table-column>
                    <el-table-column prop="systemVersion" label="系统版本"></el-table-column>
                    <el-table-column prop="clientVersion" label="app版本"></el-table-column>                     
                    
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        

    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization:localStorage.getItem('authorization'),
                query: {
                    userName: '',
                    deviceType: '',
                    startTime: '',
                    endTime: ''
                },
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                
               
            };
        },
        methods: {
            // 获取医生列表
            getData() {
                this.loading = true
                let params = {
                    userName: this.query.userName,
                    deviceType: this.query.deviceType,
                    startTime: this.query.startTime,
                    endTime: this.query.endTime                  
                }
                this.axios.post('api-b/10054/100540/' + this.pageNum + '/' +this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            search(){
                this.getData();
            },
            dateFormat:function(row,column){
            
            var date = new Date(row.gmtCreated);
            
            if(date == undefined){return ''};
            var dateTypeDate = "";
            dateTypeDate += date.getFullYear();   //年
            dateTypeDate += "-" + (date.getMonth()+1); //月
            dateTypeDate += "-" + date.getDate();  //日
            dateTypeDate += ' '
            dateTypeDate += date.getHours();
            dateTypeDate += ":"+date.getMinutes();
            dateTypeDate += ":"+date.getSeconds();
            return dateTypeDate;
        },
           
        },
        watch: {
            hospitalName: {
                handler() {
                    this.pageNum = 1
                    this.getData()
                }
            }
        },
        created() {
            this.getData()
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
</style>